<template>
  <div id="app">
    <!-- 导航 -->
    <Nav></Nav>
    <transition name="slide-fade">
      <router-view />
    </transition>
    <Footer></Footer>
    <!-- 登录 -->
    <div class="login" :class="{'active':formVisible}">
      <Login></Login>
    </div>
  </div>
</template>

<script>
import Nav from '@/views/nav/index'
import Footer from '@/views/footer/index'
import { mapState, mapMutations, mapActions } from 'vuex'
import Login from '@/views/login/index.vue'
export default {
  name: 'App',
  components: {
    Nav,
    Footer,
    Login
  },
  computed: {
    ...mapState({
      formVisible: state => state.formVisible
    })
  },
  created() {
    // 在页面加载时读取sessionStorage
    if (this.$cookies.get('muou_token')) {
      this.$store.commit('setToken', this.$cookies.get('muou_token'))
      this.$store.commit('setLogin', true)
    }

    var is_phone = this.isMobile()
    console.log('1111', is_phone)
    if (is_phone) {
      console.log(is_phone)
      console.log('去手机页面')

      window.location.href = 'http://h5.puppetchina.com/'
    }
    // 在页面刷新时将store保存到sessionStorage里
    // window.addEventListener('beforeunload', () => {
    // this.$cookies.set("muou_token",this.$store.state.token)
    // })

    // console.log('1112',this.$store.state.token)
  },
  methods: {
    isMobile() {
      var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9;
  background: rgba(0, 0, 0, 0.3);
}
.login.active {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue